var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { shouldSocketReconnect } from "../../../Common";
export var reconnects = 0;
var timeoutForReconnect = undefined;
var incrementalDelayResetTimeMS;
/* istanbul ignore next */
if (process.env.NODE_ENV === "test") {
    incrementalDelayResetTimeMS = 30; // reset every 30ms
}
/* istanbul ignore next */
if (process.env.NODE_ENV === "development") {
    incrementalDelayResetTimeMS = 60000; // reset every 1 min.
}
/* istanbul ignore next */
if (process.env.NODE_ENV === "production") {
    incrementalDelayResetTimeMS = 180000; // reset every 3 min.
}
setInterval(() => {
    reconnects = 0;
}, incrementalDelayResetTimeMS);
// TODO: add randomized modifier to the retry timeouts between 2 and 5 sec
/**
 * Create new function by binding the "additionalDelay" and "reconnectHandler" and pass by reference whenever you need.
 * @param additionalDelay delay to be incrementally applied when we start reconnecting too often
 * @param reconnectHandler function to execute when we need to reconnect
 * @param evt event object to determine if/when we need to reconnect
 */
export function sportsConnectionCloseHandler(additionalDelay, reconnectHandler, evt) {
    const [decision, delay] = shouldSocketReconnect(evt);
    if (decision) {
        clearTimeout(timeoutForReconnect);
        timeoutForReconnect = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            yield reconnectHandler();
            reconnects += 1;
        }), delay + (reconnects * additionalDelay));
    }
    return [decision, delay];
}
//# sourceMappingURL=SportsConnectionCloseHandler.js.map